import { render, staticRenderFns } from "./detailLibrary.vue?vue&type=template&id=35f83f3c&scoped=true&"
import script from "./detailLibrary.vue?vue&type=script&lang=js&"
export * from "./detailLibrary.vue?vue&type=script&lang=js&"
import style0 from "./detailLibrary.vue?vue&type=style&index=0&id=35f83f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f83f3c",
  null
  
)

export default component.exports